import moment from 'moment';
import i18n, { SUPPORTED_LOCALES, DEFAULT_LOCALE, LOCALE_STORAGE_KEY } from '@/plugins/i18n';
import { Device } from '@/utils/Capacitor';

const MOMENT_LOCALE = { es: 'es', en: 'en' };
const VUETIFY_LANG = { es: 'es', en: 'en' };

export const LOCALES = [
    { value: 'es', label: 'Español', flag: '' },
    { value: 'en', label: 'English', flag: '' },
];

export function getLocale() {
    return i18n.locale;
}

export function momentLocaleFor(locale) {
    return MOMENT_LOCALE[locale] || 'es';
}

export function vuetifyLangFor(locale) {
    return VUETIFY_LANG[locale] || 'es';
}

export function applyLocale(locale, vuetify = null, { persist = true } = {}) {
    if (!SUPPORTED_LOCALES.includes(locale)) locale = DEFAULT_LOCALE;
    i18n.locale = locale;
    moment.locale(momentLocaleFor(locale));
    if (vuetify && vuetify.lang) vuetify.lang.current = vuetifyLangFor(locale);
    if (persist) {
        try { localStorage.setItem(LOCALE_STORAGE_KEY, locale); } catch (e) { /* noop */ }
    }
    try { document.documentElement.setAttribute('lang', momentLocaleFor(locale)); } catch (e) { /* noop */ }
    return locale;
}

export async function detectDeviceLocale() {
    try {
        const code = await Device.getLanguageCode();
        if (code && String(code).toLowerCase().startsWith('en')) return 'en';
    } catch (e) { /* noop */ }
    return DEFAULT_LOCALE;
}
